<template>
  <div style="height: 80px; margin-top: 25%;">
    <SelfBuildingSquareSpinner></SelfBuildingSquareSpinner>
  </div>
</template>

<script>
// import Vue from 'vue'
import {SelfBuildingSquareSpinner} from 'epic-spinners'

export default {
  name: 'Idle',
  components: {SelfBuildingSquareSpinner},
  props: ['idleMessage'],
  data () {
    return {}
  },
  methods: {},
  mounted () {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/Idle.vue